import { render } from "./Run.vue?vue&type=template&id=6d9722fd"
const script = {}

import "./Run.vue?vue&type=style&index=0&id=6d9722fd&lang=less&scope=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__